import React from 'react';
import { number } from 'prop-types';
import { Icon } from '@chaser/components';
import style from './NotificationBell.module.scss';
import NotificationCounter from '../NotificationCounter/index';

const NotificationBell = ({ totalUnseenNotifications = undefined }) => {
  return (
    <div className={style.notificationButton}>
      <Icon name="notification" size={24} />
      {totalUnseenNotifications ? (
        <NotificationCounter
          className={style.counter}
          count={Math.min(totalUnseenNotifications, 99)}
        />
      ) : null}
    </div>
  );
};

export default NotificationBell;

NotificationBell.propTypes = {
  totalUnseenNotifications: number,
};
